import get from 'lodash-es/get'
import * as React from 'react'

import experimentsConfig from '../../../../common/constants/experiments'
import FeatureContainer from '../../containers/feature'
import LoadingCover from '../loadingCover'

import * as styles from './index.module.css'

interface IProps {
  children: React.ReactNode
  experimentsReady: boolean
}

const SearchPageContentWrapper = ({ children, experimentsReady }: IProps) => {
  return (
    <div className={styles.contentSection}>
      <FeatureContainer name="experiments:loading-cover">
        {!experimentsReady && <LoadingCover />}
      </FeatureContainer>
      {children}
    </div>
  )
}

export default SearchPageContentWrapper
